// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7b8d256b","239":"04649b60","667":"9e3249db"}[chunkId] + ".chunk.js";
};